



export const FETCH_IRRIGATION = 'FETCH_IRRIGATION',
             FETCH_IRRIGATION_EMPLOYEES = 'FETCH_IRRIGATION_EMPLOYEES',
             PREPARE_IRRIGATION_DATA = 'PREPARE_IRRIGATION_DATA',
             HANDLE_VALVE_HOURS = 'HANDLE_VALVE_HOURS',
             HANDLE_METER_GALLONS = 'HANDLE_METER_GALLONS',
             HANDLE_ENGINE_HOURS = 'HANDLE_ENGINE_HOURS',
             CREATE_IRRIGATION = 'CREATE_IRRIGATION',
             PRELOAD_METER_FORM = 'PRELOAD_METER_FORM',
             SELECT_IRRIGATION_LOG_TO_EDIT = 'SELECT_IRRIGATION_LOG_TO_EDIT',
             DELETE_IRRIGATION = 'DELETE_IRRIGATION',
             HANDLE_EDIT_VALVE_HOURS = 'HANDLE_EDIT_VALVE_HOURS',
             HANDLE_EDIT_METER_GALLONS = 'HANDLE_EDIT_METER_GALLONS',
             HANDLE_EDIT_ENGINE_HOURS = 'HANDLE_EDIT_ENGINE_HOURS',
             PREPARE_EDIT_IRRIGATION_DATA = 'PREPARE_EDIT_IRRIGATION_DATA',
             EDIT_IRRIGATION = 'EDIT_IRRIGATION',
             FETCH_IRRIGATION_REPORT = 'FETCH_IRRIGATION_REPORT',
             RESET_DASHBOARD = 'RESET_DASHBOARD',
             ERROR = 'ERROR';



// WEBPACK FOOTER //
// ./src/irrigation/types.js